import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { conversationalWorkflowCacheKeys } from "./constants";
import type { DeleteConversationalWorkflowErrors, DeleteConversationalWorkflowProps } from "./types";

/** Deletes a conversational workflow; 409 DELETE_IN_USE while a simulation case lists it. */
export const deleteConversationalWorkflow = reactQueryMutationAdapter(
  conversationalWorkflowCacheKeys,
  createMutationFetcherFunctionWithShadowError<DeleteConversationalWorkflowErrors>()(
    (props: DeleteConversationalWorkflowProps): Promise<{}> => {
      return fetch(`/${props.appGroupId}/conversational/workflow/${props.workflowId}`, "DELETE", {}, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
